import React from "react";
import styles from './video_detail.module.css'


const VideoDetail = ({ video, video: { snippet } }) => {
    return (
        <>
            <section className={styles.detail}>
            <iframe 
                title="youtubue video"
                className={styles.video}
                type="text/html"
                width="100%"
                height="500px"
                src={`https://www.youtube.com/embed/${video.id}`}
                frameBorder="0"
                allowFullScreen
            ></iframe>
            <h1>{snippet.title}</h1>
            <h3>{snippet.channelTitle}</h3>
            <pre className={styles.description}>{snippet.description}</pre>
            </section>
        </>
    );
};


export default VideoDetail;